import { useContext } from "react";

import { WizardContext, WizardContextType } from "../contexts/wizard.context";

export const useMatchMakerWizard = () => {
    return useContext(WizardContext) as WizardContextType;
};
